import React from "react";

const HTMLSub = (props: { children?: React.ReactNode }) => <sub data-component="sub">{props.children}</sub>;

export default HTMLSub;
